module.exports = __webpack_public_path__ + "static/media/login_image2.595947ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_image2.png
// module id = 1893
// module chunks = 0